import _ from 'underscore';
import moment from 'moment'
import Vue from 'vue'
import ElementUI from 'element-ui';
import App from './App.vue';
import aRouter from './router';
import init_router from './router/init_router';
import store from '@/lib/store';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

import 'element-ui/lib/theme-chalk/index.css'; //默认主题
// import './common-style/theme/custom-theme-001/theme/index.css'; //自定义主题
import '@/common-style/common.less'; //全局样式入口

// import OverwriteElButton from '@/component/overwrite-element-ui/el-button';

import vue_plugin_global_method from './lib/vue-plugin/global-method'
import init_baidu_tongji from './lib/common-service/init_baidu_tongji';

import {STATUS} from "@/lib/deprecated/utils/status";

Vue.config.productionTip = false;

// Vue.use(ElementUI);
Vue.use(ElementUI, {size: 'small'});

// Vue.use(OverwriteElButton);

Vue.use(VueAwesomeSwiper);

Vue.use(vue_plugin_global_method);


Vue.prototype.$moment = moment;
Vue.prototype._ = _;
Vue.prototype.SUCCESS_CODE = STATUS.success;

//加快webpack热更新（潘磊找的方法）
//第二步：调用init_router方法
init_router();

new Vue({
  router: aRouter,
  store,
  render: h => h(App)
}).$mount('#app');

init_baidu_tongji();
